const destinations = [
  {
    region: "Bahamas & Caribbean",
    icon: "ri-ship-line",
    trips: "Tampa cruises, PIE/TPA short flights",
    details:
      "The Port of Tampa sends cruise ships to the Bahamas, Cozumel, Jamaica, and Grand Cayman almost daily. Norwegian, Royal Caribbean, and Carnival all operate Tampa departures. For fliers, Allegiant from PIE connects to Fort Lauderdale for Caribbean gateways, while TPA offers direct flights to Nassau and Cancun. Most Caribbean destinations require 6+ months passport validity.",
  },
  {
    region: "Canada",
    icon: "ri-tree-line",
    trips: "Snowbird summer returns, Toronto baseball",
    details:
      "Clearwater's deep Canadian snowbird community drives constant northbound traffic. Spring training fans often extend their Dunedin/Blue Jays experience with trips to Toronto. Direct flights from TPA to Toronto Pearson run seasonally. Canada requires no visa for US citizens but demands a valid passport and clean entry history.",
  },
  {
    region: "Europe",
    icon: "ri-landscape-line",
    trips: "Schengen cultural trips, river cruises",
    details:
      "Tampa International offers direct flights to London (British Airways), Frankfurt (Lufthansa), and Zurich (Edelweiss). Clearwater retirees and families use these gateways for European vacations, Rhine River cruises, and multi-country Schengen tours. Remember the 3-month validity rule beyond your planned departure from Schengen.",
  },
  {
    region: "UK & Ireland",
    icon: "ri-building-line",
    trips: "Heritage travel, West End theatre, golf",
    details:
      "British Airways flies nonstop from TPA to London Heathrow — a huge advantage for Clearwater travelers. Ireland is equally accessible via connections or seasonal direct service. UK-bound travelers should note that while the UK is not in Schengen, it requires 6+ months validity for entry.",
  },
  {
    region: "Mexico & Costa Rica",
    icon: "ri-sun-line",
    trips: "Spring break, eco-tourism, beach escapes",
    details:
      "TPA offers direct flights to Cancun, Puerto Vallarta, and Liberia (Costa Rica). Spring breakers from Clearwater Beach and University of South Florida St. Petersburg flock to Cancun and Playa del Carmen. Costa Rica's eco-lodges and zip-line adventures attract families during summer break. Both destinations require 6+ months passport validity.",
  },
  {
    region: "Panama Canal & Central America",
    icon: "ri-route-line",
    trips: "Tampa cruise departures",
    details:
      "The Port of Tampa is a major embarkation point for Panama Canal cruises — 10- to 15-day journeys through one of the world's engineering marvels. These cruises often include Costa Rica, Colombia, and Aruba. A valid passport is mandatory for all Central and South American ports of call.",
  },
];

export default function ClearwaterDestinationsSection() {
  return (
    <section id="destinations" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Popular Destinations
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Clearwater Travelers Go
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            From Tampa Bay cruises to European flights and Canadian snowbird migrations,
            Clearwater residents have world-class travel options close to home.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {destinations.map((dest, i) => (
            <div
              key={i}
              className="bg-[#F8F9FB] rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all hover:shadow-md"
            >
              <div className="w-10 h-10 rounded-lg bg-[#1A365D] flex items-center justify-center mb-4">
                <i className={`${dest.icon} text-white text-lg`}></i>
              </div>
              <h3 className="font-serif text-base font-bold text-[#1A365D] mb-1">{dest.region}</h3>
              <p className="text-[#B22222] text-xs font-semibold mb-3">{dest.trips}</p>
              <p className="text-gray-600 text-sm leading-relaxed">{dest.details}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}